export enum Color {
  PRIMARY = "primary",
  SECONDARY = "secondary",
  TERTIARY = "tertiary",
  WARNING = "warning",
  DANGER = "danger",
  ERROR = "error",
  SUCCESS = "success",
}
